module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "purchase-button-container"
  }, [_c('a', {
    class: ['button', 'zoid', _vm.mutableColor],
    style: (_vm.computedStyle),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n  Purchase $" + _vm._s(_vm.package.current_price) + "\n")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-910964e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchaseButton.vue
// module id = 295
// module chunks = 1